module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/214-malawi-c95135d04c414702fa88369b3a6625e2.svg";